import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import CustomReactSelect from "./CustomReactSelect";

export const Pager = ({
	pager,
	receiveData,
	onPaginateLeft,
	onPaginateRight,
	adminPagination,
}) => {
	let { HasNext, HasPrevious, PageSize, TotalCount, CurrentPage } = pager;
	useEffect(() => {
		setSelectedNumberOfItems({
			value: PageSize,
			label: PageSize?.toString(),
		});
	}, [PageSize]);
	const [selectedNumberOfItems, setSelectedNumberOfItems] = useState({});
	const menuProps = [
		{ value: 10, label: "10" },
		{ value: 20, label: "20" },
		{ value: 50, label: "50" },
	];
	const adminMenuProps = [
		{ value: 10, label: "10" },
		{ value: 20, label: "20" },
		{ value: 50, label: "50" },
		{ value: 100, label: "100" },
		{ value: 200, label: "200" },
	];
	return (
		<div
			className="pl-3 pr-2 py-2 row justify-content-end align-items-center"
			style={{ backgroundColor: "white" }}
		>
			{/* Navigation Buttons*/}
			<div className="col-xs-auto navigationsBtns">
				<Button
					disabled={!HasPrevious}
					icon={"Back"}
					className="btn prevPg btn-sm mr-2"
					onClick={onPaginateLeft}
				>
					{" "}
					Prev
				</Button>
				<Button
					disabled={!HasNext}
					icon={"Forward"}
					className="btn nextPg btn-sm"
					onClick={onPaginateRight}
				>
					Next
				</Button>
			</div>

			{/* Total Records*/}
			<div className="col-xs-auto">
				<span className="mr-2 ml-2 pager-content"> Showing</span>
				{CurrentPage}
			</div>

			{/* Navigation DropDown*/}
			<div className="mx-2" style={{ width: "100px" }}>
				<CustomReactSelect
					paginationDropDown={true}
					options={adminPagination ? adminMenuProps : menuProps}
					value={selectedNumberOfItems}
					onChange={(value) => {
						receiveData(value.value);
						setSelectedNumberOfItems(value);
					}}
				/>
			</div>
			<div className="col-xs-auto">
				of
				<span className="mr-2 ml-2 pager-content">{TotalCount}</span>
			</div>
		</div>
	);
};
